import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import ActionsBarPres from './ActionsBarPres';
import ConsentPage from './ConsentPage';
import { PageTitle } from 'src/ui/library/PageTitle';

export const ConsentPres = ({
  toggleModal,
  percentProgress,
  isNextDisabled,
  isSubmitDisabled,
  isDraftVisible,
  isDraftDisabled,
  onSaveDraft,
  onSubmit,
  onNextPage,
  onPrevPage,
  consentState,
  togleConsent,
  onDownload,
  setCurrentPageRead,
}) => {
  const { pageCount, pageIdx, pages } = consentState;
  const consent = (pages && pages[pageIdx] && pages[pageIdx].consentData) || {};
  const pageHTML = consent && consent.consentData ? consent.consentData : '';
  const accepted = (pages[pageIdx] && pages[pageIdx].accepted) || false;
  const gdpcAccepted = (pages[pageIdx] && pages[pageIdx].gdpcAccepted) || false;
  const showGDPCAccepted = (pages[pageIdx] && pages[pageIdx].showGDPCAccepted) || false;
  const acceptable = pages && pages[pageIdx] && !!pages[pageIdx].read;
  const regex = /(<h1>)(.*)(?=<\/h1>)/g;
  const matches = pageHTML !== '' ? pageHTML.match(regex) : null;
  const title = matches && matches.length && matches.length > 0 ? matches[0].replace('<h1>', '') : intl.get('consent.pageTitle');

  return (
    <Fragment>
      <PageTitle title={title} />
      <ConsentPage
        {...{
          pageHTML,
          togleConsent,
          accepted,
          acceptable,
          gdpcAccepted,
          setCurrentPageRead,
          pageIndex: pageIdx,
          showGDPCAccepted,
        }}
      />
      <ActionsBarPres
        pageCount={pageCount}
        pageNumber={pageIdx + 1}
        percentProgress={percentProgress}
        isNextDisabled={isNextDisabled}
        isFirstPage={pageIdx === 0}
        isDraftVisible={isDraftVisible}
        isSubmitDisabled={isSubmitDisabled}
        isDraftDisabled={isDraftDisabled}
        isLastPage={pageIdx + 1 === pageCount}
        onSaveDraft={onSaveDraft}
        onCancel={toggleModal.bind(null, true)}
        onSubmit={onSubmit}
        onNextPage={onNextPage}
        onPrevPage={onPrevPage}
        onDownload={onDownload}
      />
    </Fragment>
  );
};

export default ConsentPres;
